// THE definition of a "live" order for every money total shown in the app
// — Dashboard, Orders, Reports, Billing: parallel-run test orders never
// count, cancelled orders never count. Mirrors backend/lib/liveOrders.js;
// the server also stamps `live` on each order row, which wins when present.
export function isLiveOrder(o) {
  if (!o) return false;
  if (typeof o.live === 'boolean') return o.live;
  return !o.is_test && o.status !== 'cancelled';
}
export function liveOrders(rows) { return (rows || []).filter(isLiveOrder); }
// Cancelled orders that still hold money: they need a refund decision, not a Collect button.
export function needsRefundDecision(o) { return !!o && o.status === 'cancelled' && Number(o.amount_paid || 0) > 0; }
